import { parseISO } from "date-fns";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { makeStyles } from "@mui/styles";
import { DatePicker } from "@mui/x-date-pickers";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiInputBase-root": {
      "& .MuiIconButton-root": {
        padding: 4,
      },
      "& .MuiInputBase-input": {
        color: "#66615b",
        fontSize: 12,
        height: "100%",
        padding: 10,
        paddingRight: 0,
      }
    }
  }
}));

const DateFull = ({
  allowNull,
  disablePortal,
  emptyLabel,
  label,
  locale,
  name,
  setDate,
  shrink,
  value,
  variant,
  ...props
}) => {
  const classes = useStyles();
  const intl = useIntl();

  let date;

  if (allowNull && value === null) {
    date = value;
  }
  else if (typeof value === 'string' || value instanceof String) {
    date = parseISO(value);
  }
  else {
    date = value || new Date();
  }

  return (
    <DatePicker
      className={classes.root}
      label={label}
      localeText={{
        clearButtonLabel: intl.formatMessage({ id: "common.clear" }),
      }}
      onChange={setDate}
      slotProps={{
        actionBar: {
          actions: ['clear']
        },
        popper: {
          onKeyDown: props.onKeyDown,
          onKeyUp: props.onKeyUp,
        },
        textField: {
          onKeyDown: props.onKeyDown,
          onKeyUp: props.onKeyUp,
        },
      }}
      sx={{ width: "100%" }}
      value={date}
      {...props}
    />
  );
};

DateFull.defaultProps = {
  allowNull: false,
  disablePortal: false,
  emptyLabel: "",
  locale: null,
  name: "",
  value: null,
  variant: "",
};

DateFull.propTypes = {
  allowNull: PropTypes.bool,
  disablePortal: PropTypes.bool,
  emptyLabel: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  locale: PropTypes.shape({
    culture: PropTypes.string.isRequired,
  }),
  name: PropTypes.string,
  setDate: PropTypes.func.isRequired,
  //shrink
  //value: PropTypes.instanceOf(Date),
  variant: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    locale: state.ui.locale,
  };
};

export default connect(mapStateToProps)(DateFull);
